import { render, staticRenderFns } from "./ConferenceAgentsField.vue?vue&type=template&id=5ed5f12e&"
import script from "./ConferenceAgentsField.vue?vue&type=script&lang=ts&"
export * from "./ConferenceAgentsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports